import Ivw from './tracker/Ivw'

const ivwCfg = (window as any).ivw_cfg;
let cmpData: any;
declare global {
    interface Window { __cmp: any; __tcfapi: any; haas_context: any}
}

export default class Tracking {

    constructor(){
        if(window.haas_context.tracking != 1) {
            this.run();
        }
    }

    run() {
        const obj = this;

        // Creating tracking service objects
        const ivwObj = new Ivw();
        if (typeof ivwCfg === 'object') {
            ivwObj.setConfig(ivwCfg);
        }

        // array with tracking serivce objects for consent checks
        // 06.03.2024: Tracker wurden in den head eingebaut. Lediglich IVW läuft nur noch über diese Routine
        let serviceConsentObjs = [ivwObj];

        if(window.__cmp != undefined) {
                window.__cmp("addEventListener",["settings",() => {
                    cmpData = window.__cmp('getCMPData');
                    serviceConsentObjs.forEach( (item) => {
                        obj.checkServiceConsent(item.getCmtId(), item);
                    });
                },false],null)
        }
    }

      // check consent of a service
  checkServiceConsent(serviceId: string, service: any) {
    if(typeof cmpData.vendorConsents[serviceId] !== "undefined") {
      if(!service.isLoaded()){
        //console.log('CMT: Service wurde nicht geladen: ', serviceId);
        service.load();
        return true;
      }
    } else {
      if(service.isLoaded()){
        //console.log('CMT: Service wurde schon geladen: ', serviceId);
        service.destroy();
      }
    }
    return false;
  }

}